import { useRef as m, useState as a, useEffect as f } from "react";
import { useTagName as s, useForkRef as c } from "../../../ariakit-react-utils/esm/hooks.js";
import { createComponent as i, createElement as N, createHook as l } from "../../../ariakit-react-utils/esm/system.js";
import { isButton as n } from "../../../ariakit-utils/esm/dom.js";
import { useCommand as B } from "../command/command.js";
const d = l((t) => {
  const e = m(null), o = s(e, t.as || "button"), [r, u] = a(() => !!o && n({
    tagName: o,
    type: t.type
  }));
  return f(() => {
    e.current && u(n(e.current));
  }, []), t = {
    role: !r && o !== "a" ? "button" : void 0,
    ...t,
    ref: c(e, t.ref)
  }, t = B(t), t;
}), E = i((t) => {
  const e = d(t);
  return N("button", e);
});
process.env.NODE_ENV !== "production" && (E.displayName = "Button");
export {
  E as Button,
  d as useButton
};
//# sourceMappingURL=button.js.map
